<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="popup">
                <div class="modal-container">
                    <div class="modal-body">
                        <slot name="body" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            drag: false
        }
    },
    methods: {
        handleMouseUp(evt) {
            if (!this.drag && evt.target.classList.contains('modal-wrapper')) {
                this.$emit("popUpClosed");
            }

            this.drag = false;
        }
    },
    mounted() {
        document.addEventListener('mousedown', () => this.drag = false);
        document.addEventListener('mousemove', () => this.drag = true);
        document.addEventListener('mouseup', this.handleMouseUp);
    },
    unmounted() {
        document.removeEventListener('mousedown', () => this.drag = false);
        document.removeEventListener('mousemove', () => this.drag = true);
        document.removeEventListener('mouseup', this.handleMouseUp);
    },
    watch: {
        showModal: function (val) {
            if (val) {
                document.body.classList.add("modal-open");
            }
            else {
                document.body.classList.remove("modal-open");
            }
        }
    }

};
</script>

<style scoped>
/* Base */
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity .3s ease;
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
    /* Allow for scrolls on small devices */
    top: 0;
    bottom: 0;
    position: fixed;
    overflow-y: auto;
    overflow-x: hidden;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.modal-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-width: 500px;
    height: auto;
    background-color: #fff;
    transition: all .3s ease;
    border-radius: 8px;
    box-shadow: 0 0 8px 0 #303942;
    margin: 0 auto auto auto;
}

.modal-body {
    padding: 0;
}

.fa.fa-times {
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: xx-large;
    color: #EEEEEE;
    -webkit-text-stroke: 4px #7a7b7d;
    cursor: pointer;
}
@media (max-width: 991.98px){
    .modal-container{
        width: 100%;
        min-width: 100%;
    }
    .popup{
        width: 100%;
    }
}
</style>